import { render, staticRenderFns } from "./TableCustomForm.vue?vue&type=template&id=55cfce90&"
import script from "./TableCustomForm.vue?vue&type=script&lang=js&"
export * from "./TableCustomForm.vue?vue&type=script&lang=js&"
import style0 from "./TableCustomForm.vue?vue&type=style&index=0&id=55cfce90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports